import React, { Component } from 'react';
import _  from 'lodash';

export default class Breadcrumb extends Component {
  constructor(props) {
    super(props);

    this.state = {
      breakcrumbs: props.breadcrumbs
    };
  }

  render() {
    return (
      <div className="breadcrumb">
        {this.state.breakcrumbs.map(link => {
          return (
            <span key={link.path} onClick={() => this.props.onClick(link)} className="breadcrumb-text">{_.startCase(link.label) + ' / '}</span>
          );
        })}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js